import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import HomePage from "../../Screens/HomePage/HomePage";
import ContactUs from "../../Screens/ContactUs/ContactUs";
import LoginPage from "../../../Auth/screens/LoginPage/LoginPage";
import ForgotPassword from "../../../Auth/screens/ForgotPassword/ForgotPassword";
import ResetPassword from "../../../Auth/screens/ResetPassword/ResetPassword";
import PrivacyCookiePolicy from "../../Screens/PrivacyPolicy/PrivacyCookiePolicy";
import SuccessRegister from "../../Screens/SuccessRegister/SuccessRegister";
import RegistrationFormView from "../../Screens/Registration/RegistrationFormView/RegistrationFormView";
import ResetUsername from "../../../Auth/screens/ResetPassword/ResetUsername";
import { URLS } from "../../constants";

const app = process.env.REACT_APP_PROJECT_ROUTE;

export default class CRPMainLayout extends Component {
  render() {

    const { hideMargin } = this.props

    return (
      <div className={`row ${!hideMargin && 'tenderContainer'}`}>
        <title>CRP | {window.location.pathname.split("/").pop()}</title>
        <div className="col-lg-12 col-md-12 col-sm-12">
          <div>
            <Switch>
              <Route exact path={`${URLS.BASEROUTE}`} component={HomePage} />
              <Route exact path={`${URLS.HOME}`} component={HomePage} />
              <Route exact path={`${URLS.CONTACTUS}`} component={ContactUs} />
              <Route exact path={`${URLS.LOGIN}`} component={LoginPage} />
              <Route
                exact
                path={`${URLS.FORGETPASSWORD}`}
                component={ForgotPassword}
              />
              <Route
                exact
                path={`${URLS.RESETPASSWORD}`}
                component={ResetPassword}
              />
              <Route
                exact
                path={`${URLS.RESETUSERNAME}`}
                component={ResetUsername}
              />
              <Route
                exact
                path={`${URLS.PRIVACYPOLICY}`}
                component={PrivacyCookiePolicy}
              />
              <Route
                exact
                path={`${URLS.REGISTRATION}`}
                component={RegistrationFormView}
              />
              <Route
                exact
                path={`${URLS.REGISTER_SUCCESS}`}
                component={SuccessRegister}
              />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}
